module.exports = __webpack_public_path__ + "static/media/train_5.bfa29571.png";